
<kendo-dialog-titlebar>
    {{'admin-center.header.addNewEmployeeCompany' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="addDataForm">

    <app-employee-company-form [form]="addDataForm"></app-employee-company-form>
    <span>{{'admin-center.employee.clickAddToDefineThisEntityAsEmployeeCompany' | translate}}</span>
</form>

<kendo-dialog-actions>
    <button  type="button" kendoButton (click)="confirm()" [primary]="true" submit>
        <span>{{'global.add' | translate}}</span>
    </button>
</kendo-dialog-actions>